import { atom } from "jotai";
export const isHintOpen = atom(false);
